import { Container } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const PartnerContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  [`${theme.breakpoints.up('xs')},${theme.breakpoints.up('sm')},${theme.breakpoints.up('md')}`]: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  [`${theme.breakpoints.up('lg')},${theme.breakpoints.up('xl')}`]: {
    paddingLeft: theme.spacing(22),
    paddingRight: theme.spacing(22),
  },
  // Adding classes to allow elements to break out of the padding
  // Used for edge-to-edge elements within the container
  [`${theme.breakpoints.down('lg')}`]: {
    ['& .portal-full-width']: {
      marginLeft: theme.spacing(-5),
      marginRight: theme.spacing(-5),
      ['& .portal-margin']: {
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
      },
    },
  },
}));

export default null;
